export function debounce(f, t = 200) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      f(...args);
    }, t);
  };
}

export function validSupportURI(uri, parentOrigin) {
  // Check if the URI is valid and matches the parent origin
  try {
    const url = new URL(uri);
    const parentOriginUrl = new URL(parentOrigin);
    if (url.origin !== parentOriginUrl.origin)
      throw new Error('Invalid origin');
    return true;
  } catch {
    console.error('Invalid URI:', uri);
    return false;
  }
}
